export const TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vR0JImjBea5UlJ4B8i216oL9ZFAWsAsu1iwVHX_c3PKUNNACKzXtYUJUwCorYejLdc9iNhxMlQVfCVK/pub?gid=0&single=true&output=csv';

export const BOON_VALUES_OPTIONS = [
  { label: 'First Name', value: 'First Name' },
  { label: 'Last Name', value: 'Last Name' },
  { label: 'Company', value: 'Company' },
  { label: 'Title', value: 'Title' },
  { label: 'Email - Home 1', value: 'Email - Home 1' },
  { label: 'Email - Work 1', value: 'Email - Work 1' },
  { label: 'Email - Other 1', value: 'Email - Other 1' },
  { label: 'Phone - Mobile 1', value: 'Phone - Mobile 1' },
  { label: 'Phone - Work 1', value: 'Phone - Work 1' },
  { label: 'Phone - Home 1', value: 'Phone - Home 1' },
  { label: 'Phone - Main 1', value: 'Phone - Main 1' },
  { label: 'Phone - Other 1', value: 'Phone - Other 1' },
  { label: 'Linkedin URL', value: 'Linkedin URL' },
  { label: 'Websites', value: 'Websites' },
  { label: 'Location - City', value: 'Location - City' },
  { label: 'Location - State', value: 'Location - State' },
  { label: 'Location - Country', value: 'Location - Country' },
  { label: 'Location - Zip', value: 'Location - Zip' },
  { label: 'Favorite', value: 'Favorite' },
  { label: 'Tags', value: 'Tags' },
];
